export default {
  app: {
    search: {
      applicationName: '应用名称',
      appPlaceholder: '请输入应用名称',
    },
    table: {
      applicationName: '应用名称',
      remark: '备注',
    },
    insertTitle: '新增应用',
    applicationName: '应用名称',
    editTitle: '修改应用',
    deleteTips: '请选择要删除的应用',
  },
};
